/**
 * @generated SignedSource<<843b3ee440b5f1141cbc97d041fd949e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RulesRedoInputObject = {
  perspectiveId?: string | null | undefined;
};
export type rulesPage_RulesRedoMutation$variables = {
  input: RulesRedoInputObject;
};
export type rulesPage_RulesRedoMutation$data = {
  readonly rulesRedo: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly redoneKind: string | null | undefined;
  } | null | undefined;
};
export type rulesPage_RulesRedoMutation = {
  response: rulesPage_RulesRedoMutation$data;
  variables: rulesPage_RulesRedoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redoneKind",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_RulesRedoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RulesRedoMutationPayload",
        "kind": "LinkedField",
        "name": "rulesRedo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rulesPage_RulesRedoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RulesRedoMutationPayload",
        "kind": "LinkedField",
        "name": "rulesRedo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "69dd4b94703e5e11342051ef6b126156",
    "id": null,
    "metadata": {},
    "name": "rulesPage_RulesRedoMutation",
    "operationKind": "mutation",
    "text": "mutation rulesPage_RulesRedoMutation(\n  $input: RulesRedoInputObject!\n) {\n  rulesRedo(input: $input) {\n    redoneKind\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3fb74b33c6a83ffbbcbc69085667d0d4";

export default node;
